<div *transloco="let t" class="flex items-center gap-2 rounded-md px-3 py-2" [class]="config().bg">
  <mat-icon class="size-4.5! shrink-0" [class]="config().iconColor" [svgIcon]="config().icon"></mat-icon>
  <div class="flex flex-col">
    <p class="text-xs font-medium" [class]="config().textColor">
      @if (variant() === 'warning') {
      {{ t(config().labelKey) }}
      &middot; {{ actionDate()! | translocoDate : { dateStyle: 'medium' } }} &middot;
      {{ actionDate()! | translocoDate : { timeStyle: 'short' } }}
      } @else {
      {{ t(config().labelKey) }}
      {{ actionDate()! | translocoDate : { dateStyle: 'medium' } }}
      {{ t('ORDER-DETAILS.AT') }}
      {{ actionDate()! | translocoDate : { timeStyle: 'short' } }}
      }
    </p>
    @if (variant() !== 'warning' && ipAddress()) {
    <p class="text-[0.625rem] text-ink-muted">IP: {{ ipAddress() }}</p>
    } @if (variant() === 'warning') {
    <p class="text-[0.625rem] text-ink-muted">
      {{ t('ORDER-DETAILS.EXPIRES') }}
      {{ expiryDate() | translocoDate : { dateStyle: 'medium' } }}
      @if (daysRemaining() !== null) { &middot; {{ daysRemaining() }} {{ t('ORDER-DETAILS.DAYS-REMAINING') }}
      }
    </p>
    }
  </div>
</div>
